<a class="link" routerLinkActive="active" (click)="action.emit()">
  <pu-icon [iconName]="iconName()"> </pu-icon>

  <span [translate]="i18nKey()"> </span>
</a>
